var _style, _path, _path2, _g, _path3, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 127.15 127.15",
    style: {
      enableBackground: "new 0 0 504.17 127.15"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:#FF9626;}\r\n\t.st1{fill:#4712B3;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M69.25,66.53h48.94c1.98,0,3.58,1.6,3.58,3.58v48.94c0,1.98-1.6,3.58-3.58,3.58H69.25 c-1.98,0-3.58-1.6-3.58-3.58V70.11C65.66,68.14,67.27,66.53,69.25,66.53z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.62,5.1h48.94c1.98,0,3.58,1.6,3.58,3.58v48.94c0,1.98-1.6,3.58-3.58,3.58H7.62c-1.98,0-3.58-1.6-3.58-3.58 V8.68C4.03,6.7,5.64,5.1,7.62,5.1z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M31.99,51.38c-10.1,0-18.32-8.22-18.32-18.32s8.22-18.32,18.32-18.32s18.32,8.22,18.32,18.32 S42.09,51.38,31.99,51.38z M31.99,21.92c-6.15,0-11.15,5-11.15,11.15s5,11.15,11.15,11.15s11.15-5,11.15-11.15 C43.13,26.92,38.13,21.92,31.99,21.92z"
  }))), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M7.62,66.33h48.94c1.98,0,3.58,1.6,3.58,3.58v48.94c0,1.98-1.6,3.58-3.58,3.58H7.62c-1.98,0-3.58-1.6-3.58-3.58 V69.91C4.03,67.94,5.64,66.33,7.62,66.33z"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M69.25,5.1h48.94c1.98,0,3.58,1.6,3.58,3.58v48.94c0,1.98-1.6,3.58-3.58,3.58H69.25 c-1.98,0-3.58-1.6-3.58-3.58V8.68C65.66,6.7,67.27,5.1,69.25,5.1z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 75.4,
    y: 29.57,
    className: "st0",
    width: 36.63,
    height: 7.17
  }))), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    className: "st0",
    points: "13.36,107.58 9.19,103.43 25.61,86.97 36.66,97.89 54.58,80.13 58.72,84.31 36.66,106.16 25.64,95.27  "
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.0d501e81ac16c89c4f74a6c625d250a4.svg";
export { ForwardRef as ReactComponent };